<elcia-card>
  <div class="flex h-full min-w-0 flex-col justify-center gap-1">
    <span class="min-w-0 truncate text-xs text-[var(--p-surface-600)]">{{ label() }}</span>
    <span class="text-2xl font-bold tabular-nums">{{ value() }}</span>
  </div>
</elcia-card>
